import { FC, useMemo } from 'react';
import styles from './NoResultsRecovery.module.css';
import { useCategories } from '../hooks/useCategories';
import { categoryMatchesQuery, normalizeSearchText } from '../utils/searchUtils';
import { getAppliedFilterChips, BrowseFilterState } from '../utils/filterUtils';

interface NoResultsRecoveryProps {
  filters: BrowseFilterState;
  searchQuery: string;
  onClearSearch: () => void;
  onClearAll: () => void;
  onApplyCategory: (slug: string) => void;
}

const NoResultsRecovery: FC<NoResultsRecoveryProps> = ({
  filters,
  searchQuery,
  onClearSearch,
  onClearAll,
  onApplyCategory,
}) => {
  const { categories } = useCategories();

  const activeFilterCount = getAppliedFilterChips(filters, new Map()).length;

  const categorySuggestions = useMemo(() => {
    const query = normalizeSearchText(searchQuery);
    if (!query) {
      return categories.slice(0, 4);
    }

    const matches = categories.filter((category) => categoryMatchesQuery(category, query));

    return (matches.length > 0 ? matches : categories).slice(0, 4);
  }, [categories, searchQuery]);

  return (
    <div className={styles.container}>
      <h2>Aucun événement ne correspond à votre recherche</h2>
      <p>Essayez une recherche plus large, une catégorie, ou retirez certains filtres.</p>

      <div className={styles.actions}>
        {searchQuery && (
          <button type="button" className={styles.action} onClick={onClearSearch}>
            Effacer la recherche
          </button>
        )}
        {activeFilterCount > 0 && (
          <button type="button" className={styles.actionSecondary} onClick={onClearAll}>
            Tout effacer
          </button>
        )}
      </div>

      <div className={styles.suggestions}>
        <span className={styles.label}>Essayer plutôt :</span>
        <div className={styles.suggestionList}>
          {categorySuggestions.map((category) => (
            <button
              key={category.slug}
              type="button"
              className={styles.suggestion}
              onClick={() => onApplyCategory(category.slug)}
            >
              {category.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoResultsRecovery;
